const initialState = {
  types: [],
  suborganizationGroups: [],
  notificationConditionTypes: [],
}

export const globalNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SUBORG_GROUPS_REQUEST":
      return {
        ...state,
        suborganizationGroups: [],
      }
    case "SUBORG_GROUPS_SUCCESS":
      return {
        ...state,
        suborganizationGroups: action.payload,
      }
    case "SUBORG_GROUPS_FAILURE":
      return {
        ...state,
        suborganizationGroups: [],
      }
    case "TYPES_REQUEST":
      return {
        ...state,
        types: [],
      }
    case "TYPES_SUCCESS":
      return {
        ...state,
        types: action.payload,
      }
    case "TYPES_FAILURE":
      return {
        ...state,
        types: [],
      }
    case "NOTIFICATION_CONDITION_TYPES_REQUEST":
      return {
        ...state,
        notificationConditionTypes: [],
      }
    case "NOTIFICATION_CONDITION_TYPES_SUCCESS":
      return {
        ...state,
        notificationConditionTypes: action.payload,
      }
    case "NOTIFICATION_CONDITION_TYPES_FAILURE":
      return {
        ...state,
        notificationConditionTypes: [],
      }
    default:
      return state
  }
}
